module.exports = __webpack_public_path__ + "static/img/m_role.60dfc48.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/qa/m_role.png
// module id = DJqn
// module chunks = 7